import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import RoomTypeTable from "./roomTypeTable"

const RoomTypeTableContainer = () => {


  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <RoomTypeTable  />
        </>
      </div>
    </div>
  )
}

export default RoomTypeTableContainer